<template>
	<div>
		<vx-card :title="title" :subtitle="subtitle" no-shadow card-border>
			<!-- Append Two Buttons -->
			<vx-input-group class="mb-4">
				<vs-input icon-no-border :placeholder="$t('Search')" v-model="searchQuery" class="w-full" />
			</vx-input-group>
			<!-- /Append Two Buttons -->
			<vs-divider v-show="divider" />
			<vue-perfect-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHandle">
				<vs-list>
					<vs-list-item
						v-for="visitpoint in visitPointListFilter"
						:key="visitpoint.id"
						:title="visitpoint.name"
						:subtitle="visitpoint.city + ' - ' + visitpoint.address"
					>
						<vs-button
							v-if="btnDelete"
							:title="$t('Crud.Delete')"
							color="danger"
							class="mr-2"
							type="border"
							icon-pack="feather"
							icon="icon-trash-2"
							@click="removeAssignedVisitPoint(visitpoint)"
						></vs-button>
						<vs-chip v-show="validate(visitpoint.id)" :color="'success'">
							<span>{{ $t("Selected") }}</span>
						</vs-chip>
					</vs-list-item>
					<p v-if="visitPointList.length === 0">
						{{ $t("VisitPointObject.NoAssignedVisitPoints") }}
					</p>
				</vs-list>
			</vue-perfect-scrollbar>
		</vx-card>
	</div>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleCommon from "@/store/common/moduleCommon.js";

import {BadRequestError, ServerError, NotFoundError, NetworkError} from "@/helpers/handleErrors.js";

export default {
	props: {
		btnDelete: {
			type: Boolean,
			default: true,
		},
		divider: {
			type: Boolean,
			default: true,
		},
		title: {type: String, default: ""},
		subtitle: {type: String, default: ""},
		visitPointList: {
			type: Array,
			default: () => [],
		},
		validateRepeat: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		vSelect,
		VuePerfectScrollbar,
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			activeItem: 0,
			searchQuery: "",
			visit_point_nav: 0,
			visit_point_selected: [],
			dataSelect: [],
		};
	},
	computed: {
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoits;
		},
		/**
		 * Validar si algunos de los elementos ya se encuentra en la lista de los elementos seleccionados
		 * se utiliza cuando se muestran los puntos de visita que el recurso tiene asignado
		 */
		validate() {
			return function (params) {
				if (this.validateRepeat) {
					if (this.getCheckedVisitPoints.some((vp) => vp.id === params)) {
						return true;
					}
				}
			};
		},
		visitPointListFilter() {
			const data = this.visitPointList;
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return r.name.toLowerCase().includes(this.searchQuery.toLowerCase());
			});
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		removeAssignedVisitPoint(vp) {
			this.$store.commit("moduleVisitPoint/DEL_VISIT_POINT_CHECKED", vp);
		},
		scrollHandle(evt) {},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Alarm.DeleteAllText") + ` "${this.$t("VisitPoints")}"`,
				accept: this.deleteAll,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleVisitPoint/CLEAR_ASSIGNED_VISIT_POINT");
		},
		handleError(status) {
			if (status === 401) {
				throw new BadRequestError();
			}
			if (status === 500) {
				throw new ServerError();
			}

			if (status === 722) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Roles.Permissions.NotPermissionsTitle"),
					text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${error.error}`,
					time: 5000,
				});
			}
		},
		throwSpecificError(err) {
			if (err instanceof ServerError || err instanceof NotFoundError || err instanceof NotFoundError) {
				throw err;
			}
			throw new NetworkError();
		},
	},

	created() {
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
	},
	mounted() {
		this.searchQuery = "";
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/CLEAR_ASSIGNED_VISIT_POINT");
	},
};
</script>

<style lang="scss" scoped>
#resource-create-tab-info {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}

.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}

.active {
	background-color: #f3f5f5;
}

.ag-grid-cell-chip {
	&.vs-chip-success {
		background: rgba(var(--vs-success), 0.15);
		color: rgba(var(--vs-success), 1) !important;
		font-weight: 500;
	}

	&.vs-chip-warning {
		background: rgba(var(--vs-warning), 0.15);
		color: rgba(var(--vs-warning), 1) !important;
		font-weight: 500;
	}

	&.vs-chip-danger {
		background: rgba(var(--vs-danger), 0.15);
		color: rgba(var(--vs-danger), 1) !important;
		font-weight: 500;
	}
}
</style>
